module.exports = __webpack_public_path__ + "img/utyashev.eb63d74e.jpg";